export default __webpack_public_path__ + "static/media/michael.e6853c4d.png";